
Shopify.Theme = Shopify.Theme || {};
Shopify.Theme.cart = Shopify.Theme.cart || {};
Shopify.Theme.cart.sections = Shopify.Theme.cart.sections || []

Object.defineProperty(Array.prototype, 'uniq', {
  value: function() { return Array.from(new Set(this)); }
});

const DEFAULT_OPTIONS = {
  events: true, 
  sections: [],
  callback: (cart) => {}
}

const ADD_EVENT_NAME = "cart:add"
const CHANGE_EVENT_NAME = "cart:changed"

Shopify.Theme.cart = {
  ...Shopify.Theme.cart,
  init: function () {
    window.addEventListener(ADD_EVENT_NAME, (e) => {
      e.preventDefault()
      window.dispatchEvent(new CustomEvent("modal:open", { detail: { id: 'cart-mini'}}))
    })
    
    // listen to ultimate discount app
    window.addEventListener("cg:update", (e) => {
      console.log("cg:update", e, UltimatePromotions.cart.data)
      window.dispatchEvent(new CustomEvent(CHANGE_EVENT_NAME, { detail: { ...UltimatePromotions.cart.data } }));
    })
  },
  get: async (options = DEFAULT_OPTIONS) => {
    const url = window.Shopify.routes.cartUrl + "?sections=" + [...Shopify.Theme.cart.sections, ...(options?.sections ?? [])].uniq().join(",");
    const data = await fetch(url, {
      headers: { 
        "Content-Type": "application/json", 
        "Accept": "application/json"
      },
      method: "GET",
    })
    .then((response) => response.json())
    .catch(console.error);
    return data
  },
  add: async (itemsToAdd, options = DEFAULT_OPTIONS) => {
    window.dispatchEvent(new CustomEvent('bc_enhanced_tracking:addToCart', { detail: itemsToAdd } ));
    const url = window.Shopify.routes.cartAddUrl + "?sections=" + ([...Shopify.Theme.cart.sections, ...(options?.sections ?? [])].uniq()).join(",");
    return await fetch(url, {
      body: JSON.stringify(itemsToAdd),
      headers: { 
        "Content-Type": "application/json", 
        "Accept": "application/json"
      },
      method: "POST",
    })
    .then((response) => response.json())
    .then((response) => {
      if(response.status){
        throw new Error(`${response.message}: ${response.description}`)
      }
      if(!!options.callback){
        options.callback(response);
      }
      if (options.events || true) {
        window.dispatchEvent(new CustomEvent(ADD_EVENT_NAME, { detail: { ...response, added_count: itemsToAdd.items.reduce((acc, i) => acc + Number(i.quantity), 0) } }));
        return response
      }
    })
    .catch(console.error);
  },
  update: async (itemsToUpdate, options = DEFAULT_OPTIONS) => {
    window.dispatchEvent(new CustomEvent('bc_enhanced_tracking:updateCart', { detail: itemsToUpdate } ));
    const url = window.Shopify.routes.cartUpdateUrl + "?sections=" + [...Shopify.Theme.cart.sections, ...(options?.sections ?? [])].uniq().join(",");
    return await fetch(url, {
      body: JSON.stringify(itemsToUpdate),
      headers: { 
        "Content-Type": "application/json", 
        "Accept": "application/json"
      },
      method: "POST",
    })
    .then((response) => response.json())
    .then((response) => {
      if(response.status){
        throw new Error(`${response.message}: ${response.description}`)
      }
      if(!!options.callback){
        options.callback(response);
      }
      if (options.events || true) {
        window.dispatchEvent(new CustomEvent(CHANGE_EVENT_NAME, { detail: { ...response } }));
        return response
      }
    })
    .catch(console.error);
  },
  clear: async (options = DEFAULT_OPTIONS) => {
    window.dispatchEvent(new CustomEvent('bc_enhanced_tracking:clearCart', { detail: null } ));
    const url = window.Shopify.routes.cartClearUrl + "?sections=" + [...Shopify.Theme.cart.sections, ...(options?.sections ?? [])].uniq().join(",");
    return await fetch(url, {
      body: "",
      headers: { 
        "Content-Type": "application/json", 
        "Accept": "application/json"
      },
      method: "POST",
    })
    .then((response) => response.json())
    .then((response) => {
      if(response.status){
        throw new Error(`${response.message}: ${response.description}`)
      }
      if(!!options.callback){
        options.callback(response);
      }
      if (options.events || true) {
        window.dispatchEvent(new CustomEvent(CHANGE_EVENT_NAME, { detail: { ...response } }));
        return response
      }
    })
    .catch(console.error);
  }
};

Shopify.Theme.cart.init();

class CartForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const quantities = this.querySelectorAll(`[name="updates[]"]`);
    const removeButtons = this.querySelectorAll(`[name="line-item-remove"]`);
    const addButtons = this.querySelectorAll(`cart-add`);
    const giftBags = this.querySelectorAll('[name="gift-bag"]')
    
    Shopify.Theme.cart.sections.push(this.section)
    // request section from ultimate discount app
    window.addEventListener("cg:configUpdated", () => {
      if(!!window.UltimatePromotions && UltimatePromotions.cart && UltimatePromotions.cart.sections && !UltimatePromotions.cart.sections.includes(this.section)){
        UltimatePromotions.cart.sections.push(this.section)
      }
    })
    
    quantities.forEach((qty) => {
      qty.addEventListener("change", async (e) => {
        this.loading = true;
        const res = await Shopify.Theme.cart.update({ updates: { [qty.dataset.lineItemKey]: Number(qty.value) } }, {
          events: true
        }).catch(err => {
          console.error(err)
          this.loading = false;
        });
        if(!!res.sections && !!res.sections[this.section]){
          this.updateView(res.sections[this.section]);
        }
        this.loading = false;
      });
    });

    addButtons.forEach(add => {
      add.addEventListener('click', () => {
        this.loading = true;
      })
    })

    giftBags.forEach(giftBag => {
      giftBag.addEventListener('change', () => {
        this.loading = true;
      })
    })

    removeButtons.forEach((rm) => {
      rm.addEventListener("click", async (e) => {
        e.preventDefault();
        // this.removeByUrl(rm.href);
        this.loading = true;
        const res = await Shopify.Theme.cart.update({ updates: { [rm.dataset.lineItemKey]: 0 } }, {
          events: true
        }).catch(err => {
          console.error(err)
          this.loading = false;
        });
        if(!!res.sections && !!res.sections[this.section]){
          this.updateView(res.sections[this.section]);
        }
        this.loading = false;
      });
    });
    window.addEventListener("cart:add", (e) => {
      if(!!e.detail?.sections && !!e.detail?.sections[this.section]){
        this.updateView(e.detail?.sections[this.section]);
      }
      this.loading = false;
    });
    window.addEventListener("cart:changed", (e) => {
      if(!!e.detail?.sections && !!e.detail?.sections[this.section]){
        this.updateView(e.detail?.sections[this.section]);
      }
      this.loading = false;
    });
  }

  get section() {
    return this.getAttribute("section") || "cart-main";
  }

  removeByUrl(href) {
    this.loading = true;
    const url = new URL(href);
    url.searchParams.append("sections", this.section);
    fetch(`${url}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.json())
    .then((res) => {
      this.updateView(res.sections[this.section]);
      this.loading = false;
    })
    .catch((err) => {
      console.error(err);
      this.loading = false;
    });
  }

  updateView(htmlString) {
    this.loading = true;
    const div = document.createElement("div");
    div.innerHTML = htmlString.trim();
    const newForm = div.querySelector("cart-form");
    this.replaceWith(newForm);
    window.dispatchEvent(new CustomEvent("cart:updated"));
    this.loading = false;
  }

  set loading(v) {
    if (v) {
      this.setAttribute("loading", v);
    } else {
      this.removeAttribute("loading");
    }
  }
  get loading() {
    return this.hasAttribute("loading");
  }

  static get observedAttributes() {
    return [];
  }
  attributeChangedCallback(property, oldValue, newValue) {
    if (oldValue === newValue) return;
    this[property] = newValue;
  }
}

customElements.define("cart-form", CartForm);

class CartAddComponent extends HTMLElement {
    constructor() {
        super();
    }
    get variantId(){
      return this.hasAttribute('variant-id') ? this.getAttribute('variant-id') : (document.querySelector('[name="id"]')?.value || null)
    }
    get quantity(){
      return this.hasAttribute('quantity') ? this.getAttribute('quantity') : (document.querySelector('[name="quantity"]')?.value || 1)
    }
    get currency(){
      return this.hasAttribute('currency') ? this.getAttribute('currency') : (document.querySelector('[name="currency"]')?.value || "EUR")
    }
    get compareAtPrice(){
      return this.hasAttribute('compare-at-price') ? this.getAttribute('compare-at-price') : (document.querySelector('[name="compare-at-price"]')?.value || "")
    }
    get disabled(){
      return this.hasAttribute('disabled')
    }
    connectedCallback() {
        this.onclick = (e) => {
            e.preventDefault();
            if(!this.disabled){
                Shopify.Theme.cart.add({
                  items:[{
                      id: Number(this.variantId),
                      quantity: Number(this.quantity),
                      properties: {
                        _presentment_money_compared_at_price_currency: this.currency,
                        ...(!!this.compareAtPrice ? {_presentment_money_compared_at_price: this.compareAtPrice} : {})
                      }
                  }]
              })
            }
        }
    }
}

customElements.define('cart-add', CartAddComponent);

class CartCount extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.addEventListener("cart:changed", this.update.bind(this));
    window.addEventListener("cart:add", this.increment.bind(this));
  }
  update(e) {
    console.log(e)
    if (!e.detail.item_count && e.detail.item_count != 0) return;
    this.innerHTML = `${e.detail.items.reduce((acc, i) => acc + i.quantity, 0)}`;
    this.setAttribute("data-count", this.innerHTML)
  }
  increment(e) {
    if (!e.detail.added_count) return;
    this.innerHTML = `${parseInt(this.innerHTML) + e.detail.added_count}`;
    this.setAttribute("data-count", this.innerHTML)
  }
}
customElements.define("cart-count", CartCount);